import React from 'react'
import Box from '@mui/material/Box'
import { MerchantLogo } from '@mxenabled/mxui'
import { Recurrence } from '../../../core'

interface OverlappingMerchantLogosProps {
  upcomingRecurrences: Recurrence[]
  logoSize?: number
  maxLogos?: number
}

export const OverlappingMerchantLogos: React.FC<OverlappingMerchantLogosProps> = ({
  upcomingRecurrences,
  logoSize = 32,
  maxLogos = 3,
}) => {
  const ICON_OVERLAP_X = (i: number) => i * (logoSize / 2)

  return (
    <Box
      sx={{
        position: 'relative',
        width: 64,
      }}
    >
      {upcomingRecurrences.map((recurrence, index) => {
        if (index < maxLogos) {
          return (
            <Box
              key={`${recurrence.categoryGuid}-${recurrence.merchantGuid}-${index}`}
              sx={{
                borderRadius: '4px',
                left: ICON_OVERLAP_X(index),
                outlineColor: 'common.white',
                outlineStyle: 'solid',
                outlineWidth: 2,
                position: 'absolute',
              }}
            >
              <MerchantLogo
                categoryGuid={recurrence.categoryGuid || ''}
                merchantGuid={recurrence.merchantGuid || ''}
                size={logoSize}
              />
            </Box>
          )
        }
        return null
      })}
    </Box>
  )
}
